import { isHttpClientError } from './HttpClient'

const CART_COMPLETE_ERROR_CODES = new Set([
  'CART_COMPLETE_LINE_ITEM_ADD_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_LINE_ITEM_QUANTITY_NOT_ALLOWED',
  'CART_COMPLETE_MOVE_TO_SAVE_FOR_LATER_NOT_ALLOWED',
  'CART_COMPLETE_MOVE_TO_CART_NOT_ALLOWED',
  'CART_COMPLETE_APPLY_DISCOUNT_NOT_ALLOWED',
  'CART_COMPLETE_REMOVE_DISCOUNT_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_GIFTING_FLAG_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_GIFTING_DETAILS_NOT_ALLOWED',
  'CART_COMPLETE_CLEAR_GIFTING_DETAILS_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_INVENTORY_ALLOCATION_TYPE_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_LINE_OF_BUSINESS_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_VENDOR_PO_ID_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_STORE_PROGRAM_NOT_ALLOWED',
  'CART_COMPLETE_UPDATE_LINE_ITEM_NOT_ALLOWED',
])

function getCartErrorCode(error: unknown): string | null {
  if (!isHttpClientError(error)) return null
  const data = error.response?.data
  return data?.errorCode ?? data?.errorResponse?.code ?? null
}

export function isCartCompleteError(error: unknown): boolean {
  const errorCode = getCartErrorCode(error)
  return errorCode != null && CART_COMPLETE_ERROR_CODES.has(errorCode)
}

export function getCartErrorStatusCode(error: unknown): number | null {
  if (!isHttpClientError(error)) return null
  return error.response?.data?.code ?? error.response?.status ?? null
}

export function getCartErrorMessage(error: unknown): string {
  const data = isHttpClientError(error) ? error.response?.data : null
  const apiMessage = data?.description ?? data?.message ?? null
  return (
    apiMessage ??
    // eslint-disable-next-line i18next/no-literal-string
    'Something went wrong. Please try again.'
  )
}
